import React from 'react';

import { Group, Spacing, Text } from '@vkontakte/vkui';

import { Banner } from './components/Banner';
import { Description } from './components/Description';
import { FamousPersons } from './components/FamousPersons';
import { FeedbackForm } from './components/FeedbackForm';
import { Result } from './components/Result';
import styles from './index.module.css';
import { SITE_URL } from '../../../../../components/Footer/Footer';
import { ContentResultPageProps } from '../Desktop/types';


export const MobileResultContent: React.FC<ContentResultPageProps> = ({
  temperamentData,
  hasUserAgreed,
  shareResult,
  onAppWithTestsClick,
  onRadioChange,
  title,
}) => {
  return (
    <Group style={{ padding: 0 }}>
      <Spacing size={24} />
      <Result title={title} temperamentData={temperamentData}/>
      <Spacing size={24} />
      <Description temperamentData={temperamentData}/>
      <Spacing size={24} />
      <FamousPersons temperamentData={temperamentData}/>
      <Spacing size={24} />
      <FeedbackForm 
        hasUserAgreed={hasUserAgreed}
        onRadioChange={onRadioChange}
        shareResult={shareResult}  
      />
      <Spacing size={16} />
      <Banner onAppWithTestsClick={onAppWithTestsClick}/>
      <Text className={styles.text}>
          Разработано учеными из{' '}
        <a
          href={SITE_URL}
          target="_blank"
          className={styles.link}
          style={{ marginBottom: 32 }} rel="noreferrer"
        >
            лаборатории прикладного искусственного интеллекта СПб ФИЦ РАН
        </a>
      </Text>
      <Spacing size={15} />
    </Group>
  );
};
